import { disposableSubscription } from 'common/barrels/core';

import { LooklessControl } from 'runtime/controls/looklesscontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { GenericEvent } from 'runtime/events/genericevent';
import { registerBinding } from 'runtime/bindingengine';
import { ActivityExecutionRequested } from 'runtime/events/activityexecutionrequested';
import { ActivityParameter } from 'runtime/data/activityparameter';

export class EventReceiver extends LooklessControl {
    private eventName: string;
    private respond: boolean;

    constructor(args: ControlArgs) {
        super(args);

        this.eventName = this.config['content.EventName'];
        this.applyConfigNamesake('content.RespondToEvents');

        this.subscriptions = disposableSubscription(
            this.processBindings(this.config),
            this.eventAggregator.query(GenericEvent)
                .filter(x => (this.respond !== false) && (this.eventName === x.name))
                .subscribe(x => this.handleEvent(this.config['content.ActivityName'], x.payload))
        );
    }

    private handleEvent(activityName: string, payload: string) {
        var fireEvent = () => this.triggerEvent('EventReceived');

        if (!activityName) {
            fireEvent();
            return;
        }

        this.eventAggregator.publish(new ActivityExecutionRequested(activityName, this.fieldContext, [new ActivityParameter('Content', payload)], fireEvent));
    }

    'content.RespondToEvents'(value) {
        this.respond = value !== null ? value : this.config['content.RespondToEvents'];
    }
}

registerBinding('eventreceiver', EventReceiver);